export function getFieldFromObject<T extends Record<string, any>>(
  key: string,
  object?: T
) {
  if (!object) {
    return null;
  }

  if (key in object) {
    return object[key];
  }

  return null;
}
